import React, { useEffect, useState } from 'react';
import { Plus, MapPin, Pencil, Trash2 } from 'lucide-react';
import { Card, Btn, Input, Field, Modal, Table, Spinner, ErrBox } from '../../../components/UI';
import { inventoryAPI } from '../../../utils/api';

export default function LocationsTab() {
  const [locations, setLocations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [editId, setEditId] = useState(null);
  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState({ kode: '', nama: '', alamat: '', kapasitas: '', tipe: 'GUDANG' });

  useEffect(() => { loadLocations(); }, []);

  const loadLocations = async () => {
    setLoading(true);
    setError('');
    try {
      const r = await inventoryAPI.getLocations();
      setLocations(r.data || []);
    } catch (e) { setError(e.message); }
    finally { setLoading(false); }
  };

  const handleSave = async () => {
    if (!form.kode || !form.nama) return alert('Kode dan Nama gudang wajib diisi');
    setSaving(true);
    try {
      if (editId) { await inventoryAPI.updateLocation(editId, form); }
      else { await inventoryAPI.createLocation(form); }
      closeModal();
      loadLocations();
    } catch (e) { alert('Gagal menyimpan: ' + e.message); }
    finally { setSaving(false); }
  };

  const handleEdit = (loc) => {
    setEditId(loc.id);
    setForm({ kode: loc.kode, nama: loc.nama, alamat: loc.alamat || '', kapasitas: loc.kapasitas || '', tipe: loc.tipe || 'GUDANG' });
    setShowModal(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Yakin ingin menghapus gudang ini?')) return;
    try { await inventoryAPI.deleteLocation(id); loadLocations(); }
    catch (e) { alert('Gagal menghapus: ' + e.message); }
  };

  const closeModal = () => {
    setShowModal(false);
    setEditId(null);
    setForm({ kode: '', nama: '', alamat: '', kapasitas: '', tipe: 'GUDANG' });
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 16 }}>
        <Btn icon={<Plus size={14}/>} onClick={() => setShowModal(true)}>Tambah Gudang</Btn>
      </div>

      <Card>
        {error && <div style={{ marginBottom: 12 }}><ErrBox msg={error} onRetry={loadLocations} /></div>}
        {loading ? <Spinner /> : locations.length === 0 ? (
          <div style={{ padding: '40px', textAlign: 'center', color: '#9CA3AF' }}>
            <MapPin size={40} style={{ marginBottom: 12, opacity: 0.4 }} />
            <p style={{ margin: 0 }}>Belum ada gudang. Tambahkan gudang baru untuk mulai.</p>
          </div>
        ) : (
          <Table pageSize={10} cols={[
            { key: 'kode', label: 'Kode', nowrap: true },
            { key: 'nama', label: 'Nama Gudang' },
            { key: 'alamat', label: 'Alamat', render: v => v || '-' },
            { key: 'kapasitas', label: 'Kapasitas', align: 'right', render: v => v ? `${v} unit` : '-' },
            { key: 'tipe', label: 'Tipe', align: 'center' },
            { key: 'unit_name', label: 'Unit', render: v => v || '-' },
            { key: 'id', label: 'Aksi', render: (id, row) => (
              <div style={{ display: 'flex', gap: 6 }}>
                <Btn size="sm" variant="secondary" icon={<Pencil size={12}/>} onClick={() => handleEdit(row)}>Edit</Btn>
                <Btn size="sm" variant="danger" icon={<Trash2 size={12}/>} onClick={() => handleDelete(id)}>Hapus</Btn>
              </div>
            )},
          ]} data={locations} />
        )}
      </Card>

      {showModal && (
        <Modal title={editId ? 'Edit Gudang' : 'Tambah Gudang Baru'} onClose={closeModal}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
            <Field label="Kode Gudang" required>
              <Input value={form.kode} onChange={e => setForm({ ...form, kode: e.target.value })} placeholder="GDG-001" />
            </Field>
            <Field label="Nama Gudang" required>
              <Input value={form.nama} onChange={e => setForm({ ...form, nama: e.target.value })} placeholder="Gudang Utama" />
            </Field>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
            <Field label="Alamat">
              <Input value={form.alamat} onChange={e => setForm({ ...form, alamat: e.target.value })} placeholder="Jl. Raya ..." />
            </Field>
            <Field label="Kapasitas (unit)">
              <Input type="number" value={form.kapasitas} onChange={e => setForm({ ...form, kapasitas: e.target.value })} placeholder="0" />
            </Field>
          </div>
          <Field label="Tipe">
            <select value={form.tipe} onChange={e => setForm({ ...form, tipe: e.target.value })} style={{ width: '100%', padding: '9px 12px', border: '1.5px solid #E5E7EB', borderRadius: 8, fontSize: 13, outline: 'none', boxSizing: 'border-box' }}>
              <option value="GUDANG">Gudang</option>
              <option value="TOKO">Toko</option>
              <option value="SHOWROOM">Showroom</option>
              <option value="LAB">Laboratorium</option>
              <option value="LAIN">Lainnya</option>
            </select>
          </Field>
          <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 20 }}>
            <Btn variant="secondary" onClick={closeModal}>Batal</Btn>
            <Btn onClick={handleSave} disabled={saving}>{saving ? 'Menyimpan...' : 'Simpan'}</Btn>
          </div>
        </Modal>
      )}
    </div>
  );
}